export const selectSessionAuthToken = state => state.session.aut;
export const selectHasSessionUser = state => !!state.session.aut;
